module.exports = __webpack_public_path__ + "img/carshina22_10.5dd2bc38.jpg";